import React, { useState, useEffect } from 'react';
import styles from './Navigation.module.css';
import img1 from './../../assets/navigation_images/cazane.png';
import img2 from './../../assets/navigation_images/centrale-peleti.png';
import img3 from './../../assets/navigation_images/cazane-industriale.png';
import img4 from './../../assets/navigation_images/boilere.png';
import img5 from './../../assets/navigation_images/arzatoare.png';
import { allProducts, SOLID_FUEL_BOILERS, PELLET_BOILERS, INDUSTRIAL_BOILERS, BOILERS, BURNERS } from "./../API/ProductsAPI";
import useTabTitle from '../Hooks/useTabTitle';

const Navigation = (props) => {
  const setTabTitle = useTabTitle('Catalog de producție')

  const filterProducts = (type, tabName) => {
    setTabTitle(tabName)
    props.setActiveCategory(type)
    props.setProducts(allProducts.filter(el => el.type.includes(type)))
    props.productsRef.current.scrollIntoView({ behavior: 'smooth' });
  }


  return (
    <nav className={styles.navigation}>
      <div className={styles.container}>
        <ul>
          <li>
            <div onClick={() => filterProducts(SOLID_FUEL_BOILERS, 'Cazane pe combustibil solid')} className={styles.navLink}>
              <img src={img1} alt="Cazane" className={styles.navImage} />
              <span className={styles.name}>Cazane pe combustibil solid</span>
            </div>
          </li>
          <li>
            <div onClick={() => filterProducts(PELLET_BOILERS, 'Centrale pe peleți')} className={styles.navLink}>
              <img src={img2} alt="Centrale pe peleți" className={styles.navImage} />
              <span className={styles.name}>Centrale pe peleți</span>
            </div>
          </li>
          <li>
            <div onClick={() => filterProducts(INDUSTRIAL_BOILERS, 'Centrale și cazane industriale')} className={styles.navLink}>
              <img src={img3} alt="Cazane industriale" className={styles.navImage} />
              <span className={styles.name}>Centrale și cazane industriale</span>
            </div>
          </li>
          <li>
            <div onClick={() => filterProducts(BOILERS, 'Boilere și acumulatoare')} className={styles.navLink}>
              <img src={img4} alt="Boilere" className={styles.navImage} />
              <span className={styles.name}>Boilere și acumulatoare</span>
            </div>
          </li>
          <li>
            <div onClick={() => filterProducts(BURNERS, 'Arzătoare pe peleți')} className={styles.navLink}>
              <img src={img5} alt="Arzătoare" className={styles.navImage} />
              <span className={styles.name}>Arzătoare pe peleți</span>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;
